import { userInfoSync } from 'hub-http/userInfo';
const getGatesAsSet = () => {
  try {
    return new Set(userInfoSync().gates);
  } catch (e) {
    return new Set();
  }
};
export const isUngatedFor = (() => {
  const cacheResults = new Map();
  let cachedGates = new Set();
  const checkGate = gateName => {
    if (cacheResults.has(gateName)) {
      var _cacheResults$get;
      return (_cacheResults$get = cacheResults.get(gateName)) !== null && _cacheResults$get !== void 0 ? _cacheResults$get : false;
    }
    if (cachedGates.size === 0) {
      cachedGates = getGatesAsSet();
    }
    const hasGate = cachedGates.has(gateName);
    cacheResults.set(gateName, hasGate);
    return hasGate;
  };

  // Expose cache clearing for testing purposes
  checkGate.clearCache = () => {
    cacheResults.clear();
    cachedGates = new Set();
  };
  return checkGate;
})();